import { Box, Text } from '@chakra-ui/react'
import React from 'react'

const NavToggle = () => {


  return (
   <>
   <Box margin={"auto"}><Text  color="rgb(84 92 106)" fontSize={"15px"} fontWeight="500" fontFamily={`system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`} >Ongoing</Text></Box>
          <Box margin={"auto"}><Text  color="rgb(84 92 106)" fontSize={"15px"} fontWeight="500" fontFamily={`system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`} >Asisting</Text></Box>
          <Box margin={"auto"}><Text  color="rgb(84 92 106)" fontSize={"15px"} fontWeight="500" fontFamily={`system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`} >Set by me</Text></Box>
          <Box margin={"auto"}><Text  color="rgb(84 92 106)" fontSize={"15px"} fontWeight="500" fontFamily={`system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`} >Following</Text></Box>
   
   
   </>
  )
}

export default NavToggle